module.exports = __webpack_public_path__ + "img/extra-section-icon.29248b8f.svg";